import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LoginInitialState, LoggedUserType } from "../../utils/Types";
import { LOGIN_STATUS, STORAGE_KEY } from "../../utils/Constant";
import { logout, registeredEmp } from "../../services";
import {
  clearSession,
  getFromLocalStorage,
  removeFromLocalStorage,
  saveInLocalStorage,
} from "../../utils/Util";

const blankUser: LoggedUserType = {
  candidateId: 0,
  candidateUniqueId: "",
  employeeUniqueId: "",
  firstname: "",
  lastName: "",
  employeeName:"",
  userActivationStatus: 0,
  userActivationStatusName: "",
  accessToken: "",
  accessExpiryTime: "",
  resetToken: "",
  resetExpiryTime: "",
  mobileNumber: 0,
  emailId: "",
  loginType: 0,
  loginTypeName: "",
  roleId: -1,
  permissions: [],
  roleName: [],
  userId: '',
  sessionId: ''
};
export const initialState: LoginInitialState = {
  status: LOGIN_STATUS.NO_AUTHENTICATED,
  user: blankUser,
};

export const getRegisteredEmployees = createAsyncThunk("dummyAPI", async () => {
  const res = await registeredEmp({});
  return res.data;
});
export const onLogout = createAsyncThunk("update/logout", async () => {
  const res = await logout();
  return res.data;
});
export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setAuthenticated: (state: LoginInitialState, action) => {
      state.status = action.payload.status;
      state.user = action.payload.user;
      saveInLocalStorage(
        STORAGE_KEY.AUTH_DATA,
        JSON.stringify(action.payload.user)
      );
    },
    setLocalLogout: (state:LoginInitialState, action) => {
      state.status = LOGIN_STATUS.NO_AUTHENTICATED;
      state.user = blankUser;
      removeFromLocalStorage(STORAGE_KEY.AUTH_DATA);
      removeFromLocalStorage(STORAGE_KEY.ITUS);
      // localStorage.clear();
      clearSession();
    },
    checkAuthenticated: (state: LoginInitialState, action) => {
      const data = getFromLocalStorage(STORAGE_KEY.AUTH_DATA);
      if (data) {
        const sessionData: LoggedUserType = JSON.parse(data);
        if (sessionData && sessionData.accessToken) {
          state.status = LOGIN_STATUS.AUTHENTICATED;
          state.user = sessionData;
        }
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getRegisteredEmployees.fulfilled, (state: LoginInitialState, action) => {
        state.status = LOGIN_STATUS.AUTHENTICATED;
      });
  },
});
export const loginSelector = (state: any) => state.login;
export const { setAuthenticated, setLocalLogout, checkAuthenticated } =
  loginSlice.actions;
export default loginSlice.reducer;
